import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { IMPACT_ACTION_PLAN_TYPES } from '../../lib/schema.js';

ActionPlanTypeFilter.propTypes = {
  selectedActionPlanTypes: PropTypes.array.isRequired,
};

ActionPlanTypeFilter.defaultProps = {
  selectedActionPlanTypes: [],
};

function ActionPlanTypeFilter({ selectedActionPlanTypes, navigateAction }) {
  const selectedCount = selectedActionPlanTypes.length;

  const handleSelect = useCallback(
    (actionPlanType) =>
      navigateAction({
        actionPlanTypes: actionPlanType
          ? xor(selectedActionPlanTypes, [actionPlanType])
          : [],
      }),
    [selectedActionPlanTypes]
  );

  const renderMenuItem = useCallback(
    (type) => (
      <React.Fragment key={type}>
        <MenuItem
          active={selectedActionPlanTypes.includes(type)}
          eventKey={type}
          onSelect={handleSelect}
        >
          {type}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedActionPlanTypes]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Action Plan Type</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="action-plan-type-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {IMPACT_ACTION_PLAN_TYPES.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default ActionPlanTypeFilter;
